import ConsumerService from '../../../services/consumers.service';
import CourseService from '../../../services/courses.service';

export async function getConsumer(store, id) {
	const consumer = await ConsumerService().getConsumer(id);
	store.setState({ ConsumerDetails: { ...store.state.ConsumerDetails, consumer } });
}

export async function getClassGroups(store, courseId) {
	const classGroups = await CourseService().getClassGroups(courseId);
	store.setState({ ConsumerDetails: { ...store.state.ConsumerDetails, classGroups } })
}

export async function getCourses(store) {
	let courses = await CourseService().getAllCourses();
	const configs = store.state.ConsumerDetails.consumer.consumerConfigData;
	courses = courses.map(c => { return { ...c, isDisabled: configs.find(pc => pc.courseId === c.id) !== undefined } });
	store.setState({ ConsumerDetails: { ...store.state.ConsumerDetails, courses } })
}

export function selectCourse(store, courseId) {
	const courseConfig = store.state.ConsumerDetails.consumer.consumerConfigData.find(x => x.courseId === courseId) || null;
	store.setState({ ConsumerDetails: { ...store.state.ConsumerDetails, courseConfig, courseId } });
}

export function addOrEditConsumerConfiguration(store, courseConfig) {
	const newConsumerConfigData = [...store.state.ConsumerDetails.consumer.consumerConfigData];
	let index = newConsumerConfigData.findIndex(val => val.courseId === courseConfig.courseId);
	if (index === -1)
		newConsumerConfigData.push({ ...courseConfig })
	else
		newConsumerConfigData.splice(index, 1, { ...courseConfig })

	store.setState({ ConsumerDetails: { ...store.state.ConsumerDetails, consumer: { ...store.state.ConsumerDetails.consumer, consumerConfigData: newConsumerConfigData } } });
}

export function deleteCourseConfiguration(store, courseId) {
	const state = store.state;
	const newConsumerConfigData = [...state.ConsumerDetails.consumer.consumerConfigData];
	let index = newConsumerConfigData.findIndex(v => v.courseId === courseId)
	if (index === -1)
		return;

	newConsumerConfigData.splice(index, 1);
	store.setState({ ConsumerDetails: { ...store.state.ConsumerDetails, consumer: { ...state.ConsumerDetails.consumer, consumerConfigData: newConsumerConfigData } } });
}

export async function submitConsumerConfiguration(store, consumer) {
	if (consumer.apiKey)
		await ConsumerService().editConsumerConfiguration(consumer.consumerId, consumer.consumerConfigData);
	else
		await ConsumerService().createConsumerConfiguration(consumer.consumerId, consumer.consumerConfigData);
}
